window.currentSlug = "";
window.oldSlug = "";

function updateSlug() {
  window.oldSlug = window.currentSlug;
  window.currentSlug = document.querySelector('.pagecont').getAttribute('data-slug');
  document.documentElement.setAttribute('data-slug', window.currentSlug);
}

export default updateSlug;
